const simulateTarget = new EventTarget();
export function onShare(callback) {
    var _a;
    if (typeof window === 'undefined')
        return;
    if (typeof navigator === 'undefined')
        return;
    if (!navigator.serviceWorker)
        return;
    const onEvent = async (event) => {
        if (event.data.type === 'pwa-share') {
            const text = event.data.text;
            let url = event.data.url;
            const title = event.data.title;
            if (text || url || title) {
                if (!url && text && isUrl(text)) {
                    url = text;
                }
                callback({ url, text, title });
            }
            else {
                console.debug('Got unrecognized PWA share:', event.data);
            }
        }
    };
    navigator.serviceWorker.addEventListener('message', onEvent);
    simulateTarget.addEventListener('simulate-share', (e) => {
        const event = e;
        callback(event.detail);
    });
    (_a = navigator.serviceWorker.controller) === null || _a === void 0 ? void 0 : _a.postMessage({ type: 'share-ready' });
}
function isUrl(text) {
    try {
        new URL(text);
        return true;
    }
    catch (_a) {
        return false;
    }
}
// debugging tools
if (typeof window !== 'undefined') {
    window.simulateShare = (data) => {
        if (typeof window === 'undefined')
            return;
        simulateTarget.dispatchEvent(new CustomEvent('simulate-share', { detail: data }));
    };
}
//# sourceMappingURL=share.js.map